import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { MplButton, MplModal } from '@mopla/ui';

interface IMyTicketCancellationModalProps {
	open: boolean;
	onConfirm: () => void;
	onAbort: () => void;
	isLoading?: boolean;
}

/**
 * Cancellation confirmation modal for preordered tickets
 */
export const MyTicketCancellationModal = ({
	open,
	onConfirm,
	onAbort,
	isLoading = false,
}: IMyTicketCancellationModalProps) => {
	const { t } = useTranslation('ticketshop');

	return (
		<MplModal
			open={open}
			testId="myTicketDetail-cancellationModal"
			title={t('my_ticket_detail.cancellation_modal.title')}
			content={
				<Typography variant="b2">
					{t('my_ticket_detail.cancellation_modal.description')}
				</Typography>
			}
			buttons={
				<>
					<MplButton
						variant="contained"
						fullWidth
						onClick={onConfirm}
						disabled={isLoading}
						showLoader={isLoading}
						testId="myTicketDetail-cancellationModal-confirm-button"
					>
						{t('my_ticket_detail.cancellation_modal.confirm_button')}
					</MplButton>
					<MplButton
						variant={isLoading ? 'contained' : 'outlined'}
						fullWidth
						onClick={onAbort}
						disabled={isLoading}
						testId="myTicketDetail-cancellationModal-abort-button"
					>
						{t('my_ticket_detail.cancellation_modal.abort_button')}
					</MplButton>
				</>
			}
		/>
	);
};
